<template>
  <div class="row">
    <div class="col-md-12 col-lg-12">
      <q-form ref="editForm">
        <c-card title="유해위험기계기구 기본정보" class="cardClassDetailForm">
          <template slot="card-button">
            <q-btn-group outline >
              <!-- <c-btn v-if="popupParam.hhmHazardousMachineryId" label="삭제" :editable="editable" icon="delete_forever" @btnClicked="removeHazard" /> -->
              <c-btn
                v-if="editable"
                :url="saveUrl"
                :isSubmit="isSave"
                :param="equipInfo"
                :mappingType="saveType"
                label="저장"
                icon="save"
                @beforeAction="saveInfo"
                @btnCallback="saveCallback" 
              />
            </q-btn-group>
          </template>
          <template slot="card-detail">
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <!-- :disabled="disabled" -->
              <c-text
                required
                :editable="editable"
                label="형식(규격)"
                name="machineryName"
                v-model="equipInfo.machineryName">
              </c-text>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
              <c-text
                required
                :editable="editable"
                name="machineryClassification"
                label="설비종류"
                v-model="equipInfo.machineryClassification"
              ></c-text>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
                <!-- :disabled="disabled" -->
              <c-text
                :afterIcon="[
                  { name: 'search', click: true, callbackName: 'add', color: 'indigo-5' },
                  { name: 'close', click: true, callbackName: 'remove', color: 'red' }
                ]"
                :editable="editable"
                label="설비번호"
                :close="false"
                name="equipmentNo"
                @add="add"
                @remove="remove"
                v-model="equipInfo.equipmentNo"
              >
              </c-text>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <!-- :disabled="disabled" -->
              <c-text
                :editable="editable"
                label="설비위치"
                name="emplacementPlace"
                v-model="equipInfo.emplacementPlace">
              </c-text>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
              <c-text
                :editable="editable"
                label="용량"
                name="volume"
                v-model="equipInfo.volume">
              </c-text>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
                <!-- :disabled="disabled" -->
              <c-text
                suffix="개"
                :editable="editable"
                label="수량"
                name="amount"
                type="number"
                v-model="equipInfo.amount">
              </c-text>
            </div>
            <!-- <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
              <c-process
                :editable="editable"
                label="단위공정"
                multiple="multiple"
                name="subProcessCd"
                v-model="equipInfo.subProcessCd">
              </c-process>
            </div>
            <div class="col-6">
              <c-multi-select
                :editable="editable"
                codeGroupCd="REGULATION_BILL_CD"
                itemText="codeName"
                itemValue="code"
                label="관련 법규"
                name="relatedLaws"
                maxValues="3"
                v-model="equipInfo.relatedLaws">
              </c-multi-select>
            </div> -->
            <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
              <!-- :disabled="disabled" -->
              <c-dept-multi type="edit"  label="담당부서" name="departmentDeptCd" v-model="equipInfo.departmentDeptCd" />
            </div>
            <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
              <c-field
                :editable="editable"
                label="담당자"
                type="user" 
                name="departmentUserId"
                v-model="equipInfo.departmentUserId">
              </c-field>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
              <c-plant
                required
                :editable="editable"
                type="edit"
                name="plantCd"
                v-model="equipInfo.plantCd" />
            </div>
            <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
              <c-checkbox
                :isFlag="true"
                :editable="editable"
                label="사용여부"
                name="useFlag"
                v-model="equipInfo.useFlag">
              </c-checkbox>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <c-textarea
                :editable="editable"
                label="비고"
                :rows="2"
                name="remark"
                v-model="equipInfo.remark">
              </c-textarea>
            </div>
          </template>
        </c-card>
        <c-card class="cardClassDetailForm" title="안전검사정보">
          <template slot="card-detail">
            <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
              <c-checkbox
                :isFlag="true"
                :editable="editable"
                label="안전인증 대상"
                name="certificateSubjectFlag"
                v-model="equipInfo.certificateSubjectFlag">
              </c-checkbox>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
              <c-checkbox
                :isFlag="true"
                :editable="editable"
                label="자율안전확인신고대상"
                name="autoSafetyFlag"
                v-model="equipInfo.autoSafetyFlag">
              </c-checkbox>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
              <c-checkbox
                :isFlag="true"
                :editable="editable"
                trueLabel="대상"
                falseLabel="비대상"
                label="안전검사 대상"
                name="inspectionSubjectFlag"
                v-model="equipInfo.inspectionSubjectFlag">
              </c-checkbox>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
              <c-select
                :editable="editable"
                type="edit"
                codeGroupCd="MDM_EQUIP_CYCLE_CD"
                itemText="codeName"
                itemValue="code"
                label="검사주기"
                name="inspectionCycle"
                v-model="equipInfo.inspectionCycle">
              </c-select>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
              <c-text
                :editable="editable"
                label="안전인증(자율안전)번호"
                name="safetyNumber"
                v-model="equipInfo.safetyNumber">
              </c-text>
            </div>
          </template>
        </c-card>
      </q-form>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>
<script>
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'hazardEquipmentInfo',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        hhmHazardousMachineryId: '',
      }),
    },
    count: {
      type: Number,
      default: function() {
        return 0;
      },
    },
  },
  data() {
    return {
      editable: true,
      equipInfo: {
        hhmHazardousMachineryId: '',
        equipmentCd: '', 
        equipmentName: '',
        plantCd: null,
        machineryClassification: null,
        amount: '1',
        inspectionSubjectFlag: "N",
        autoSafetyFlag: "N",
        certificateSubjectFlag: "N",
        inspectionCycle: null,
        machineryName: '',
        departmentDeptCd: '',
        departmentUserId: '',
        relatedLaws: '',
        remark: '',
        subProcessCd: '',
        useFlag: "Y",
        volume: '',
        regUserId: '',
        chgUserId: '',
        safetyNumber: '',
        hazardEquipmentHistoryModels: [],
        equipmentImproveModels: [],
      },
      useFlagItems: [
        { code: 'Y', codeName: '사용' },
        { code: 'N', codeName: '미사용' },
      ],
      targetCdItems: [
        { code: "Y", codeName: "대상" },
        { code: "N", codeName: "비대상" },
      ], // 대상여부
      popupOptions: {
        target: null,
        title: "",
        visible: false,
        top: "",
        param: {},
        closeCallback: null,
      },
      saveUrl: 'transactionConfig.sop.hhm.hazard.check.insert.url',
      saveType: 'POST',
      isSave: false,
      checkUrl: '',
      insertUrl: '',
      deleteUrl: '',
      updateUrl: '',
      updateMode: false,
      getUrl: '',
    };
  },

  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
    disabled() {
      return this.equipInfo.equipmentCd !== '';
    }
  },
  watch: {
    'count'() {
      this.getDetail();
    },
    'equipInfo'() {
      this.$emit('transInfo', this.equipInfo);
    },
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      this.getUrl = selectConfig.sop.hhm.hazard.check.get.url;
      this.checkUrl = selectConfig.sop.hhm.hazard.check.check.url;
      this.insertUrl = transactionConfig.sop.hhm.hazard.check.insert.url;
      this.updateUrl = transactionConfig.sop.hhm.hazard.check.update.url;
      this.deleteUrl = transactionConfig.sop.hhm.hazard.check.delete.url;

      this.getDetail();
    },
    getDetail() {
      if (this.popupParam.hhmHazardousMachineryId) {
        this.$http.url = this.$format(this.getUrl, this.popupParam.hhmHazardousMachineryId);
        this.$http.type = 'GET';
        this.$http.request((_result) => {
          // 빈값들 filter
          this.equipInfo = this.$_.clone(_result.data);
          this.updateMode = true;
        },);
      }
    },
    saveInfo() {
      if (this.popupParam.hhmHazardousMachineryId) {
        this.saveUrl = this.updateUrl;
        this.saveType = 'PUT';
      } else {
        this.saveUrl = this.insertUrl;
        this.saveType = 'POST';
      }
      this.$refs['editForm'].validate().then(_result => {
        if (_result) { 
            // this.$http.url = this.checkUrl
            // this.$http.type = 'GET';
            // this.$http.param = this.equipInfo;
            // this.$http.request((_result) => {
              // if (_result.data > 0) {
              //   window.getApp.$emit('ALERT', {
              //     title: '안내', // 안내
              //     message: '사업장 내 이미 존재하는 기계관리번호입니다.', // 사업장 내 이미 존재하는 기계관리번호입니다.
              //     type: 'warning', // success / info / warning / error
              //   });
              //   return;
              // } else {
                window.getApp.$emit('CONFIRM', {
                  title: '확인',
                  message: '저장하시겠습니까?',
                  // TODO : 필요시 추가하세요.
                  type: 'info', // success / info / warning / error
                  // 확인 callback 함수
                  confirmCallback: () => {
                    this.equipInfo.regUserId = this.$store.getters.user.userId;
                    this.equipInfo.chgUserId = this.$store.getters.user.userId;
                    this.isSave = !this.isSave;
                  },
                  // 취소 callback 함수
                  cancelCallback: () => {
                  },
                  });
                // }
            // },);
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    add() {
      // 초기에는 userId에 tempId를 부여
      this.popupOptions.title = '설비 검색'; // 설비 검색
      this.popupOptions.param = {
        type: 'single',
        hazardousFlag: 'Y'
      };
      this.popupOptions.target = () => import(`${'@/pages/common/equip/equipPop.vue'}`);
      this.popupOptions.width = '60%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeEquipmentPopup;
    },
    closeEquipmentPopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data.length > 0) {
          this.equipInfo.equipmentCd = data[0].equipmentCd; // 설비코드
          this.equipInfo.equipmentNo = data[0].equipmentNo; // 설비번호
          this.equipInfo.machineryName = data[0].equipmentName; // 설비명
          this.equipInfo.amount = data[0].amount; // 수량
          // this.equipinfo.emplacementPlace = data[0].equipmentLocation // 설비위치
          this.equipInfo.subProcessCd = data[0].subProcessCd; // 단위공정
          this.equipInfo.departmentDeptCd = data[0].managementDepts; // 담당부서
          // 설비 주기와 관련법규 연결하면 주석 풀어도 됨
          this.equipInfo.relatedLaws= data[0].relatedLaws;
      }
    },
    remove() {
      if (this.equipInfo.equipmentCd) {
        this.equipInfo.equipmentCd = '';
        this.equipInfo.equipmentNo = '';
        this.equipInfo.machineryName = '';
        this.equipInfo.amount = '';
        this.equipInfo.departmentDeptCd = '';
        this.equipInfo.subProcessCd = '';
      }
    },
    saveCallback(equipInfo) {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      if (!this.popupParam.hhmHazardousMachineryId) {
        this.popupParam.hhmHazardousMachineryId = equipInfo.data;
        this.$emit('changeStatus')
      }
      this.getDetail();
    },
    removeHazard() {
      window.getApp.$emit('CONFIRM', {
        title: '확인',
        message: '삭제하시겠습니까?',
        // TODO : 필요시 추가하세요.
        type: 'warning', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.$http.url = this.$format(this.deleteUrl, this.popupParam.hhmHazardousMachineryId);
          this.$http.type = 'DELETE';
          this.$http.request(() => {
            window.getApp.$emit('APP_REQUEST_SUCCESS');
            this.$emit('closePopup')
          },);
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
    },
  }
};
</script>